import { gql } from '__generated__'

export const GetCandidateDocumentsForDownload = gql(/* GraphQL */ `
    query GetCandidateDocumentsForDownload($candidateId: ID!) {
        candidate(id: $candidateId) {
            id
            documents {
                id
                documentType
                documentKey
            }
        }
    }
`)

export const GetDocumentDownloadUrl = gql(/* GraphQL */ `
    query GetDocumentDownloadUrl(
        $documentId: String!
        $forceDownload: Boolean
    ) {
        download(documentId: $documentId, forceDownload: $forceDownload) {
            url
        }
    }
`)
